import { render, staticRenderFns } from "./NsAddressCo.vue?vue&type=template&id=34b44ead&"
import script from "./NsAddressCo.vue?vue&type=script&lang=js&"
export * from "./NsAddressCo.vue?vue&type=script&lang=js&"
import style0 from "./NsAddressCo.vue?vue&type=style&index=0&lang=scss&module=%24x&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports